export default "__VITE_ASSET__2fd86157__"